var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomePage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 14a2 2 0 0 0 2 2h2v-5h2v5h2a2 2 0 0 0 2-2V6h3L8 0 0 6h3zm0-9h1v9a1 1 0 0 0 1 1h1v-5h4v5h1a1 1 0 0 0 1-1V5h1L8 1.25z",
  clipRule: "evenodd"
})));
export default SvgHomePage;